export default __webpack_public_path__ + "static/media/CartrTab.58f06e53.png";